import { Link } from 'react-router-dom';
import { articles } from '@/mocks/guagua';
import { formatViews, getHotArticles, getCategoryName } from '@/utils/content';

const tagPool = Array.from(new Set(articles.flatMap((item) => item.tags))).slice(0, 14);

export default function NewsSidebar() {
  const hot = getHotArticles().slice(0, 5);

  return (
    <div className="space-y-5">
      <div className="rounded-lg bg-background-50 border border-background-200 p-5">
        <h3 className="font-heading text-lg font-bold text-foreground-950 flex items-center gap-2 mb-3">
          <i className="ri-fire-line text-primary-500" aria-hidden="true"></i>
          本周热门
        </h3>
        <ol className="space-y-1">
          {hot.map((item, index) => (
            <li key={item.id}>
              <Link
                to={`/news/${item.id}`}
                className="group flex items-start gap-3 py-3 border-b border-background-100 last:border-0 cursor-pointer"
              >
                <span
                  className={`font-heading text-base font-bold leading-none w-5 shrink-0 ${
                    index < 3 ? 'text-primary-500' : 'text-foreground-300'
                  }`}
                >
                  {index + 1}
                </span>
                <span className="flex-1 min-w-0">
                  <span className="block text-sm text-foreground-800 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </span>
                  <span className="block mt-1 text-xs text-foreground-400">
                    {getCategoryName(item.categorySlug)} · {formatViews(item.views)} 阅读
                  </span>
                </span>
              </Link>
            </li>
          ))}
        </ol>
      </div>

      <div className="rounded-lg bg-background-100 border border-background-200 p-5">
        <h3 className="font-heading text-lg font-bold text-foreground-950 flex items-center gap-2 mb-3">
          <i className="ri-price-tag-3-line text-secondary-500" aria-hidden="true"></i>
          热门标签
        </h3>
        <div className="flex flex-wrap gap-2">
          {tagPool.map((tag) => (
            <Link
              key={tag}
              to={`/news?q=${encodeURIComponent(tag)}`}
              className="px-3 py-1.5 rounded-full text-xs bg-background-50 border border-background-200 text-foreground-600 hover:border-secondary-400 hover:text-secondary-700 transition-colors cursor-pointer"
            >
              #{tag}
            </Link>
          ))}
        </div>
      </div>

      <div className="rounded-lg bg-foreground-950 p-5">
        <h3 className="font-heading text-lg font-bold text-background-50 mb-2">不想错过最新更新？</h3>
        <p className="text-sm text-background-300 leading-relaxed mb-4">
          回到首页可以看快讯时间线，那里是全天滚动的，几分钟就能扫完。
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-1 px-4 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
        >
          回首页看快讯
          <i className="ri-arrow-right-line" aria-hidden="true"></i>
        </Link>
      </div>
    </div>
  );
}